export const duplicateOrderEvents = {
  collapseEventName: 'editOrder.collapseDuplicateOrder',
  uncollapseEventName: 'editOrder.uncollapseDuplicateOrder',
};
